module.exports = __webpack_public_path__ + "img/EF.4e85cc37.png";